import React, { useState, useEffect } from 'react';
import { FaCalendarAlt, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const DashboardTimePicker = ({ timeframe, selectedDate, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [view, setView] = useState(() => {
    if (timeframe === 'Year') return 'years';
    if (timeframe === 'Month') return 'months';
    return 'days';
  });
  
  const [yearPage, setYearPage] = useState(() => Math.floor(selectedDate.getFullYear() / 12) * 12);
  const [currentViewDate, setCurrentViewDate] = useState(selectedDate);
  
  useEffect(() => {
    setCurrentViewDate(selectedDate);
    setYearPage(Math.floor(selectedDate.getFullYear() / 12) * 12);
    if (timeframe === 'Year') setView('years');
    else if (timeframe === 'Month') setView('months');
    else setView('days');
    setIsOpen(false);
  }, [selectedDate, timeframe]);

  if (!['Week', 'Month', 'Year'].includes(timeframe)) return null;

  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  
  const getDisplayText = () => {
    if (timeframe === 'Year') return selectedDate.getFullYear().toString();
    if (timeframe === 'Month') return `${monthNames[selectedDate.getMonth()]} ${selectedDate.getFullYear()}`;
    if (timeframe === 'Week') {
      const d = new Date(selectedDate);
      const day = d.getDay();
      const diff = d.getDate() - day + (day === 0 ? -6 : 1);
      const startOfWeek = new Date(d.setDate(diff));
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      return `${startOfWeek.getDate()} ${monthNames[startOfWeek.getMonth()].substring(0,3)} - ${endOfWeek.getDate()} ${monthNames[endOfWeek.getMonth()].substring(0,3)}, ${endOfWeek.getFullYear()}`;
    }
  };

  const handlePrev = (e) => {
    e.stopPropagation();
    if (view === 'days') setCurrentViewDate(new Date(currentViewDate.getFullYear(), currentViewDate.getMonth() - 1, 1));
    else if (view === 'months') setCurrentViewDate(new Date(currentViewDate.getFullYear() - 1, currentViewDate.getMonth(), 1));
    else if (view === 'years') setYearPage(yearPage - 12);
  };

  const handleNext = (e) => {
    e.stopPropagation();
    if (view === 'days') setCurrentViewDate(new Date(currentViewDate.getFullYear(), currentViewDate.getMonth() + 1, 1));
    else if (view === 'months') setCurrentViewDate(new Date(currentViewDate.getFullYear() + 1, currentViewDate.getMonth(), 1));
    else if (view === 'years') setYearPage(yearPage + 12);
  };

  const year = currentViewDate.getFullYear();
  const month = currentViewDate.getMonth();

  const firstDayOfMonth = new Date(year, month, 1);
  const lastDayOfMonth = new Date(year, month + 1, 0);
  const daysInMonth = lastDayOfMonth.getDate();
  let startOffset = firstDayOfMonth.getDay() - 1;
  if (startOffset < 0) startOffset = 6;

  const selectDay = (day, e) => {
    e.stopPropagation();
    onChange(new Date(year, month, day));
    setIsOpen(false);
  };

  const selectMonth = (idx, e) => {
    e.stopPropagation();
    if (timeframe === 'Month') {
      onChange(new Date(year, idx, 1));
      setIsOpen(false);
    } else {
      setCurrentViewDate(new Date(year, idx, 1));
      setView('days');
    }
  };

  const selectYear = (y, e) => {
    e.stopPropagation();
    if (timeframe === 'Year') {
      onChange(new Date(y, 0, 1));
      setIsOpen(false);
    } else {
      setCurrentViewDate(new Date(y, month, 1));
      setView(timeframe === 'Month' ? 'months' : 'days');
    }
  };

  return (
    <div style={{ position: 'relative', width: '280px', marginTop: '12px' }}>
      <div onClick={() => setIsOpen(!isOpen)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px', background: '#ffffff', borderRadius: '12px', border: '1px solid #E5E9F2', cursor: 'pointer', boxShadow: '0 2px 10px rgba(0,0,0,0.02)' }}>
        <span style={{ fontWeight: '600', color: '#1B1B29', fontSize: '15px' }}>{getDisplayText()}</span>
        <FaCalendarAlt style={{ color: '#604BE8' }} />
      </div>

      {isOpen && (
        <>
          <div onClick={() => setIsOpen(false)} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1000 }} />
          <div style={{ position: 'absolute', top: 'calc(100% + 8px)', right: 0, width: '320px', background: '#ffffff', borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.15)', padding: '24px', zIndex: 1001, border: '1px solid #e2e8f0', animation: 'slideDown 0.2s ease', boxSizing: 'border-box' }}>
            
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
              <button onClick={handlePrev} style={{ width: '36px', height: '36px', background: '#F3F6FB', border: 'none', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#1B1B29' }}>
                <FaChevronLeft />
              </button>
              
              <div style={{ display: 'flex', gap: '8px' }}>
                {view === 'days' && (
                  <>
                    <span onClick={(e) => { e.stopPropagation(); setView('months'); }} style={{ fontWeight: '700', fontSize: '16px', color: '#1B1B29', cursor: 'pointer', padding: '4px 8px', borderRadius: '6px' }} onMouseEnter={(e) => e.target.style.background = '#F3F6FB'} onMouseLeave={(e) => e.target.style.background = 'transparent'}>
                      {monthNames[month]}
                    </span>
                    <span onClick={(e) => { e.stopPropagation(); setYearPage(Math.floor(year / 12) * 12); setView('years'); }} style={{ fontWeight: '700', fontSize: '16px', color: '#1B1B29', cursor: 'pointer', padding: '4px 8px', borderRadius: '6px' }} onMouseEnter={(e) => e.target.style.background = '#F3F6FB'} onMouseLeave={(e) => e.target.style.background = 'transparent'}>
                      {year}
                    </span>
                  </>
                )}
                {view === 'months' && (
                  <span onClick={(e) => { e.stopPropagation(); setYearPage(Math.floor(year / 12) * 12); setView('years'); }} style={{ fontWeight: '700', fontSize: '16px', color: '#1B1B29', cursor: 'pointer' }}>
                    {year}
                  </span>
                )}
                {view === 'years' && (
                  <span style={{ fontWeight: '700', fontSize: '16px', color: '#1B1B29' }}>
                    {yearPage} - {yearPage + 11}
                  </span>
                )}
              </div>

              <button onClick={handleNext} style={{ width: '36px', height: '36px', background: 'transparent', border: 'none', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#1B1B29' }}>
                <FaChevronRight />
              </button>
            </div>

            {view === 'days' && (
              <>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', textAlign: 'center', marginBottom: '16px' }}>
                  {["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"].map((w, i) => (
                    <span key={i} style={{ fontSize: '13px', fontWeight: '700', color: '#1B1B29' }}>{w}</span>
                  ))}
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '8px 4px' }}>
                  {Array.from({ length: startOffset }).map((_, i) => <div key={`empty-${i}`} />)}
                  {Array.from({ length: daysInMonth }).map((_, i) => {
                    const day = i + 1;
                    const isSelected = selectedDate.getFullYear() === year && selectedDate.getMonth() === month && selectedDate.getDate() === day;
                    return (
                      <button
                        key={day}
                        onClick={(e) => selectDay(day, e)}
                        style={{ height: '36px', width: '100%', border: 'none', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', fontWeight: isSelected ? '700' : '600', cursor: 'pointer', background: isSelected ? '#604BE8' : 'transparent', color: isSelected ? '#ffffff' : '#1B1B29', transition: 'all 0.2s ease' }}
                      >
                        {day}
                      </button>
                    );
                  })}
                </div>
              </>
            )}

            {view === 'months' && (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px' }}>
                {monthNames.map((mName, index) => {
                  const isSelected = selectedDate.getFullYear() === year && selectedDate.getMonth() === index;
                  return (
                    <button
                      key={mName}
                      onClick={(e) => selectMonth(index, e)}
                      style={{ height: '42px', border: 'none', borderRadius: '10px', background: isSelected ? '#604BE8' : '#F3F6FB', color: isSelected ? '#ffffff' : '#1B1B29', fontWeight: '600', fontSize: '14px', cursor: 'pointer' }}
                    >
                      {mName.substring(0, 3)}
                    </button>
                  );
                })}
              </div>
            )}

            {view === 'years' && (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px' }}>
                {Array.from({ length: 12 }).map((_, i) => {
                  const y = yearPage + i;
                  const isSelected = selectedDate.getFullYear() === y;
                  return (
                    <button
                      key={y}
                      onClick={(e) => selectYear(y, e)}
                      style={{ height: '42px', border: 'none', borderRadius: '10px', background: isSelected ? '#604BE8' : '#F3F6FB', color: isSelected ? '#ffffff' : '#1B1B29', fontWeight: '600', fontSize: '14px', cursor: 'pointer' }}
                    >
                      {y}
                    </button>
                  );
                })}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default DashboardTimePicker;
